import { Show } from "solid-js";
import { ArrowRight } from "~/assets/svg_icons/svg_icons";
import HubbleImage from "~/widgets/hubble_image";

export type BrandCardTelescopeRnrProps = {
  imageUrl: string;
  name: string;
  discountPercentage?: number;
  onClick: () => void;
  cardBackgroundColor: string;
  forceDarkTheme?: boolean;
  heroImageUrl: string | null;
  showHeroImage: boolean;
};

export function BrandCardTelescopeLargeRnr(props: BrandCardTelescopeRnrProps) {
  const hasDiscount = () => {
    return (props.discountPercentage ?? 0) > 0;
  };

  const CustomBrandUI = () => {
    return (
      <>
        <div class="absolute left-1/2 top-[-27.93px] h-20 w-[260px] -translate-x-1/2">
          <div
            class="absolute inset-0"
            style={{
              background: `radial-gradient(50% 50% at 50% 50%, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%)`,
              transform: "scale(2.5, 3.85)",
            }}
          />
        </div>

        {/* Bottom decorative element */}
        <div class="absolute bottom-[-37px] left-1/2 h-[46px] w-[152px] -translate-x-1/2 opacity-10">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="191"
            height="90"
            viewBox="0 0 191 90"
            fill="none"
          >
            <g opacity="0.1" filter="url(#filter0_f_408_5263)">
              <ellipse cx="95" cy="103" rx="76" ry="23" fill="#171717" />
            </g>
            <defs>
              <filter
                id="filter0_f_408_5263"
                x="-61"
                y="0"
                width="312"
                height="206"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feGaussianBlur
                  stdDeviation="40"
                  result="effect1_foregroundBlur_408_5263"
                />
              </filter>
            </defs>
          </svg>
        </div>

        {/* Brand Logo Container - centered */}
        <div class="flex h-full w-full items-center justify-center py-5 ">
          <div class="aspect-square h-full rounded-full border border-[rgba(159,159,169,0.16)] ">
            <img
              src={props.imageUrl}
              alt={props.name}
              class="h-full w-full rounded-full object-cover"
            />
          </div>
        </div>
      </>
    );
  };

  return (
    <div
      class=" group relative flex cursor-pointer flex-col items-start gap-2  "
      classList={{
        "telescope-dark-theme": props.forceDarkTheme,
      }}
      onClick={props.onClick}
    >
      {/* Brand Card Container */}
      <div
        class="relative aspect-[190.3/113.4] w-full overflow-hidden rounded-xl"
        style={{
          "background-color": props.cardBackgroundColor
            ? props.cardBackgroundColor
            : "transparent",
        }}
      >
        <Show
          when={props.heroImageUrl && props.showHeroImage}
          fallback={<CustomBrandUI />}
        >
          <HubbleImage
            src={props.heroImageUrl ?? ""}
            alt={props.name}
            class="h-full w-full rounded-xl object-cover"
          />
        </Show>
        <div
          class="pointer-events-none absolute inset-0  rounded-[12px]"
          style={{
            background:
              "linear-gradient(to bottom, rgba(255,255,255,0.3), rgba(0,0,0,0.1))",
            mask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
            "-webkit-mask":
              "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
            "mask-composite": "exclude",
            "-webkit-mask-composite": "xor",
            padding: "1px",
          }}
        />
      </div>

      {/* Brand Info */}
      <div class="relative flex w-full flex-col items-start px-1">
        {/* Brand Name */}
        <div class="w-full overflow-hidden text-ellipsis whitespace-nowrap text-caption-medium uppercase tracking-[0.4px] text-text-normal-primary">
          {props.name}
        </div>

        {/* Discount Info */}
        <Show when={hasDiscount()}>
          <div class="flex items-end ">
            <span class="text-para-2-medium text-success-base">
              {props.discountPercentage}
              <span class="mb-[0px] ml-[1px] text-label-medium text-success-base">
                % off
              </span>
            </span>
          </div>
        </Show>
        <ArrowRight
          class={`absolute  right-2  text-text-normal-primary opacity-0 transition-opacity group-hover:opacity-100 ${hasDiscount() ? "bottom-[4px]" : "bottom-[0px]"}`}
          width={16}
          height={16}
        />

        {/* Hover Arrow */}
      </div>
    </div>
  );
}
